// extracted by mini-css-extract-plugin
export default {"root":"HHOHPsCh0966SQU4al4G","primary":"MSLGpueJfP5WqxGdzZaC","loading":"myPJasGY2zGHHjXzzSmt","placeHolderShimmer":"lwSDsMfyTMb1ciMHh964"};